import React from 'react'

import AssignToModalView from 'components/AssignToModal/AssignToModal'
import { useBulkAssignDataAccessRequests } from 'services/data-access-requests/hooks/useBulkAssignDataAccessRequests'
import { useBulkUnassignDataAccessRequests } from 'services/data-access-requests/hooks/useBulkUnassignDataAccessRequests'
import { useGetAssignableAssigneesForDataAccessRequest } from 'services/data-access-requests/hooks/useGetAssignableAssigneesForDataAccessRequest'
import { useGetUserInfo } from 'services/user/hooks/useGetUserInfo'

interface DataAccessRequestAssignToModalProps {
  assignedTo?: string
  onClose: () => void
  open: boolean
  requestId: string
}

export const DataAccessRequestAssignToModal: React.FC<DataAccessRequestAssignToModalProps> = ({
  assignedTo,
  onClose,
  open,
  requestId
}) => {
  const { data: actingUser } = useGetUserInfo()
  const assignableAssigneesQuery = useGetAssignableAssigneesForDataAccessRequest(requestId, {
    enabled: open
  })
  const bulkAssignMutation = useBulkAssignDataAccessRequests({ onSuccess: onClose })
  const bulkUnassignMutation = useBulkUnassignDataAccessRequests({ onSuccess: onClose })

  const options = React.useMemo(
    () => assignableAssigneesQuery.data?.data.map(item => ({ label: item.email, value: item._id })) ?? [],
    [assignableAssigneesQuery.data]
  )

  return (
    <AssignToModalView
      open={open}
      onClose={onClose}
      assignedTo={assignedTo}
      options={options}
      isLoadingOptions={assignableAssigneesQuery.isLoading}
      isError={assignableAssigneesQuery.isError}
      isSubmitting={bulkAssignMutation.isPending || bulkUnassignMutation.isPending}
      onAssign={(assigneeId, reviewConfirmed) =>
        bulkAssignMutation.mutate({ requestIds: [requestId], assigneeId, reviewConfirmed })
      }
      onUnassign={() => bulkUnassignMutation.mutate({ requestIds: [requestId] })}
      actingUserId={actingUser?._id}
    />
  )
}

export default DataAccessRequestAssignToModal
